import { useState } from 'react';
import axios from 'axios';

const initialState = {
  name: '',
  email: '',
  message: '',
  thanks_message: '',
};

export const Contact = (props) => {
  const [{ name, email, message, thanks_message }, setState] =
    useState(initialState);

  // update state when form field gets changed
  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };

  // run when form is submitted
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(name, email, message);

    axios
      .post(
        'https://europe-west2-thunderingherd-20fe4.cloudfunctions.net/app/sendmail',
        {
          formName: name,
          formEmail: email,
          formText: message,
        },
      )
      .then((result) => {
        console.log(result);
        setState((prevState) => ({
          ...prevState,
          thanks_message: result.data,
        }));
      })
      .catch((error) => {
        console.log(error);
        setState((prevState) => ({
          ...prevState,
          thanks_message:
            'Sorry, something has gone wrong. Please email us at moo@thunderingherd.co.uk',
        }));
      });

    // reset form entries
    e.target.reset();
  };

  return (
    <div>
      <div id='contact'>
        <div className='container'>
          <div className='col-md-8'>
            <div className='row'>
              <div className='section-title'>
                <h2>Get In Touch</h2>
                <p>
                  Please fill out the form below to send us an email and we will
                  get back to you as soon as possible.
                </p>
              </div>
              <form name='sentMessage' validate='true' onSubmit={handleSubmit}>
                <div className='row'>
                  <div className='col-md-6'>
                    <div className='form-group'>
                      <input
                        type='text'
                        id='name'
                        name='name'
                        className='form-control'
                        placeholder='Name'
                        required
                        onChange={handleChange}
                      />
                      <p className='help-block text-danger'></p>
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <div className='form-group'>
                      <input
                        type='email'
                        id='email'
                        name='email'
                        className='form-control'
                        placeholder='Email'
                        required
                        onChange={handleChange}
                      />
                      <p className='help-block text-danger'></p>
                    </div>
                  </div>
                </div>
                <div className='form-group'>
                  <textarea
                    name='message'
                    id='message'
                    className='form-control'
                    rows='4'
                    placeholder='Message'
                    required
                    onChange={handleChange}
                  ></textarea>
                  <p className='help-block text-danger'></p>
                </div>
                <p id='success' className='form-group'>
                  {thanks_message}
                </p>
                <button type='submit' className='btn btn-custom btn-lg'>
                  Send Message
                </button>
              </form>
            </div>
          </div>
          <div className='col-md-3 col-md-offset-1 contact-info'>
            <div className='contact-item'>
              <h3>Contact Info</h3>
              <p>
                <span>
                  <i className='fa fa-map-marker'></i> Training Location
                </span>
                {props.data ? props.data.address : 'loading'}
              </p>
            </div>
            <div className='contact-item'>
              <p>
                <span>
                  <i className='fa fa-envelope-o'></i> Email
                </span>{' '}
                {props.data ? props.data.email : 'loading'}
              </p>
            </div>
          </div>
          <div className='col-md-12'>
            <div className='row'>
              <div className='social'>
                <ul>
                  <li>
                    <a
                      href={props.data ? props.data.facebook : '/'}
                      rel='noreferrer'
                    >
                      <i className='fa fa-facebook'></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href={props.data ? props.data.instagram : '/'}
                      rel='noreferrer'
                    >
                      <i className='fa fa-instagram'></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id='footer'>
        <div className='container text-center'>
          <p>
            Design by{' '}
            <a
              href='https://github.com/issaafalkattan/React-Landing-Page-Template'
              rel='nofollow noreferrer'
            >
              Issaaf Kattan
            </a>
          </p>
          <p>
            Photo credits{' '}
            <a href='https://www.ultimatephotos.org/' rel='nofollow noreferrer'>
              UltimatePhotos
            </a>
            ,{' '}
            <a
              href='https://www.instagram.com/showgameulti/'
              rel='nofollow noreferrer'
            >
              The ShowGame
            </a>
            , and{' '}
            <a
              href='https://www.instagram.com/nkolakovic/'
              rel='nofollow noreferrer'
            >
              Nkolakovic
            </a>
            .
          </p>
          <p>Message us to be credited if we've missed you.</p>
        </div>
      </div>
    </div>
  );
};
